import React from 'react'

const HowItWorks = ({ cellData }) => (
  <section>
    <div className="container mt-5">
      <div className="row">
        <div className="col-12 mb-0 mb-md-5">
          <h2 className="font-weight-bold col-12 col-lg-8 mx-auto text-center mb-4">How it works</h2>
        </div>
      </div>
      <div className="row text-center">
        {cellData.map((cell) => (
          <div className="col-12 col-md-4 my-2">
            <div className="bg-dark py-4 p-4 h-100">
              {<cell.icon />}
              <h4 className="pt-3">{cell.header}</h4>
              <p className="py-2 smaller">{cell.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section >
)

export default HowItWorks
